const ABOUT_IMG =
  "https://images.pexels.com/photos/9799186/pexels-photo-9799186.jpeg?auto=compress&cs=tinysrgb&w=1400";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-zinc-950 border-y border-zinc-900"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 relative" data-testid="about-image">
          <div className="aspect-[4/5] relative overflow-hidden border border-zinc-800">
            <img
              src={ABOUT_IMG}
              alt="Pacific community gathering — Tribal Designz custom uniforms NZ"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a1530]/80 via-transparent to-transparent" />
          </div>
          <div className="hidden md:block absolute -bottom-6 -right-6 bg-gold text-zinc-950 px-6 py-4">
            <div className="font-display text-3xl uppercase leading-none">Pasifika</div>
            <div className="font-display text-3xl uppercase leading-none">Owned</div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="text-xs uppercase tracking-[0.3em] text-gold font-semibold">
            Our story
          </p>
          <h2 className="mt-3 font-display uppercase text-4xl md:text-6xl tracking-tight leading-[0.95]">
            The specialist for <br />
            <span className="text-teal-400">Pacific heritage uniforms</span>
          </h2>
          <p className="mt-6 text-zinc-300 text-lg leading-relaxed">
            Tribal Designz exists for one reason — to help Pacific
            churches and communities show up united, dressed with pride. We're
            not a generic apparel company. We specialise in custom Samoan,
            Tongan and Cook Islands polo uniforms for the groups that matter
            most: your church, your ministry, your aiga, your kainga, your
            village.
          </p>
          <p className="mt-4 text-zinc-400 leading-relaxed">
            Auckland-based, Pasifika-led. Every uniform we deliver is designed
            in partnership with you, drawing on the cultural symbols and
            colours your community knows by heart. From Sunday-morning choir
            polos to 200-person conference kits to once-in-a-decade reunion
            sets — we treat every order like it represents who you are. Because
            it does.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-xl">
            <Stat label="Samoan, Tongan, Cook Islands" value="Pacific" />
            <Stat label="Free mockup &amp; quote" value="24 hrs" />
            <Stat label="Order minimum" value="10+" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value }) {
  return (
    <div className="border-l-2 border-gold pl-4">
      <div className="font-display uppercase text-2xl md:text-3xl text-white">{value}</div>
      <div className="text-xs uppercase tracking-wider text-zinc-500 mt-1" dangerouslySetInnerHTML={{ __html: label }} />
    </div>
  );
}
